const features = [
  {
    icon: "ri-fire-fill",
    title: "עישון איטי ועמוק",
    desc: "הכל עשוי בעבודת יד על גריל עצים אמיתי, בתהליך עישון ממושך שנותן לבשר את הטעמים והארומה הבלתי נשכחים",
  },
  {
    icon: "ri-award-fill",
    title: "נתחים מובחרים",
    desc: "נתחים מובחרים מהמעשנה - בריסקט, אסאדו, ספריבס טלה, ארעייס, צ'וריסו ועוד. כולם מוגשים לצד רטבים ביתיים",
  },
  {
    icon: "ri-scissors-cut-fill",
    title: "חיתוך פרונטלי חי",
    desc: "הבשר נחתך מול האורחים ליצירת חוויה ויזואלית מרהיבה. האורחים ליקקו את הידיים מרוב התלהבות!",
  },
  {
    icon: "ri-truck-fill",
    title: "הפוד טראק מגיע אליכם",
    desc: "הפוד טראק שלנו מגיע לכל מקום, לכל חגיגה - בת מצווה, יום הולדת, אירוע חברה, כנס ועוד",
  },
];

const WhyUs = () => {
  return (
    <section className="py-20 bg-[#1a0a00]" dir="rtl">
      <div className="max-w-7xl mx-auto px-6">
        <div className="text-center mb-14">
          <span
            className="inline-block bg-[#e85d04]/20 text-[#f4a261] px-4 py-1.5 rounded-full text-sm font-semibold mb-4"
            style={{ fontFamily: "'Assistant', sans-serif" }}
          >
            למה Meet n' Meat
          </span>
          <h2
            className="text-white font-black text-4xl md:text-5xl mb-4"
            style={{ fontFamily: "'Assistant', sans-serif" }}
          >
            ביס שישאיר תמיד
            <br />
            <span className="text-[#e85d04]">טעם של עוד</span>
          </h2>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6">
          {features.map((f) => (
            <div
              key={f.title}
              className="bg-white/5 border border-white/10 rounded-2xl p-6 hover:bg-white/10 transition-colors duration-200"
            >
              <div className="w-12 h-12 flex items-center justify-center bg-[#e85d04]/20 rounded-xl mb-4">
                <i className={`${f.icon} text-[#e85d04] text-2xl`}></i>
              </div>
              <h3
                className="text-white font-bold text-lg mb-2"
                style={{ fontFamily: "'Assistant', sans-serif" }}
              >
                {f.title}
              </h3>
              <p
                className="text-white/60 text-sm leading-relaxed"
                style={{ fontFamily: "'Assistant', sans-serif" }}
              >
                {f.desc}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default WhyUs;
